// extracted by mini-css-extract-plugin
module.exports = {"container":"e_M7","sizeMedium":"e_N7","sizeSmall":"e_O7","icon":"e_P7"};